/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SvgIcon } from '@material-ui/core';
import { InstructionsOutline as InstructionsOutlineIcon } from '../components/Icons';

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: 500,
    color: 'var(--color-colorPrimary-main)',
    backgroundColor: 'var(--color-backgroundColors-hoverRowAlt)',
    height: 35,
    width: 120,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid',
    borderColor: 'var(--color-colorPrimary-main)',
    borderRadius: 3,
    margin: '0 2px',
    textDecoration: 'none',

    '& svg': {
      display: 'flex',
      position: 'relative',
      top: 3,
      marginRight: 4,
    },
  },
}));

const InstructionsHighlightButton = () => {
  const classes = useStyles();

  return (
    <a
      className={classes.root}
      href="https://quantiply.tech/documentation/getting-started/instructions/"
      target="_blank"
    >
      <SvgIcon component={InstructionsOutlineIcon} />
      Instructions
    </a>
  );
};

export default InstructionsHighlightButton;
